import React from 'react';
import Footer from '../../common_components/Footer';
import Header from '../../common_components/Header';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ConnectWithUs from '../../common_components/ConnectWithUs';

function ResetPassword() {
  return (
    <React.Fragment>
      <Header></Header>
      <ForgotPassword />
      <ConnectWithUs />
      <Footer></Footer>
    </React.Fragment>
  );
}

export default ResetPassword;
